<template>
  <consulta ref="modal" :columns="columns" :process="process"
            id="consultar-indicador"
            titulo="Consultar Atos Notariais"
            :exportar="exportar"
            :mlAuto="!marcados.length" :custom-actions="actions">

    <template #cabecalho>
      <li class="list-inline-item" v-if="multiplos">
        <a @click.prevent="selecionarTodos()" title="Selecionar Todos" class="icon">
          <i class="fal fa-check-circle"></i>
        </a>
      </li>

      <li class="list-inline-item" v-if="multiplos">
        <a @click.prevent="selecionarTodos(true)" title="Limpar Seleção" class="icon">
          <i class="fal fa-circle"></i>
        </a>
      </li>
    </template>

    <template #filtros>
      <filtrar-consulta class="w-100" :options="opcoesConsulta" :dto="filtros" />
    </template>

    <template #row="{ row }">
      <tr>
        <td width="50px" class="text-center" v-if="multiplos">
          <input :id="`check-${row.id}`" class="form-check-input" @click="selectRegistro(row)"
                 style="margin: -5px 0 0 -6px;position: relative;" type="checkbox" v-model="row.selecionado">
        </td>

        <td width="50px" class="text-center">
          <a href class="icon" @click.prevent.stop="detalhes(row.id)">
            <i class="fal fa-landmark"></i>
          </a>
        </td>

        <td width="200px" class="pointer icon" @click="select(row)">
          <a>{{ tipoRegistro(row.livro) }} {{ row.codigo | inteiro }}{{row.livroLetra ? `-${row.livroLetra}` : ''}}</a>
        </td>

        <td width="160px">{{ row.abertura | datahora }}</td>
        <td width="120px">{{ row.livroRegistro }}</td>
        <td width="120px">{{ row.folhaInicial }}</td>
        <td width="120px">{{ row.folhaFinal }}</td>
        <td width="120px">{{ nomearStatus(row.status) }}</td>
      </tr>
    </template>

    <template #footer>
      <v-button v-if="marcados.length > 0" class="btn btn-outline-primary mr-2 ml-auto" :run="select" :params="[marcados]">
        Adicionar
      </v-button>
    </template>
  </consulta>
</template>

<script>
import FrontBusiness from "@/business/FrontBusiness.js";
import FiltrarConsulta from "@/components/Consultas/components/FiltrarConsulta.vue";
import Consulta from "@/components/Consultas/Consulta.vue";
import ModalFichaAntiga from "@/components/ModalFichaAntiga.vue";
import Utils from "@/commons/Utils.js";
import ConsultarRegistroNotas from "@/components/RegistroNotas/ConsultarRegistroNotas.vue";
import UsuarioBusiness from "@/business/crud/UsuarioBusiness";
import RegistroNotasBusiness from "@/business/indicadores/RegistroNotasBusiness";
import DetalhesRegistroNotas from "@/components/RegistroNotas/Detalhes/DetalhesRegistroNotas.vue";
export default {
  name: "ConsultarRegistroNotas",
  components: {FiltrarConsulta, Consulta},
  props: {
    multiplos : {type : Boolean, default : false},
    seleciona : {type : Boolean, default : true},
    status : String,
    registro: String,
    livro: String
  },
  data() {
    return {
      buscar : 'REGISTRO_NOTAS',
      mode: 'novo',
      opcoesConsulta: RegistroNotasBusiness.camposConsulta().filter(i => {return !i.status || (i.status && !this.status) || (this.status && i.status && (i.status).includes(this.status))}),
      filtros : {
        filtros: []
      },
      marcados: [],
    }
  },
  computed:{
    columns(){
      let columns = [
        {label: '', show: this.multiplos, field: 'selecionar', headerClass: 'column__botao', sortable: false, name: 'selecionar'},
        {label: '', field: 'id', headerClass: 'column__botao', sortable: false, name: 'id'},
        {label: 'Número Registro', field: 'i.codigo', headerClass: 'column__codigo_doc', name: 'codigo'},
        {label: 'Data Lavratura', field: 'i.abertura', headerClass: 'column__codigo_doc', name: 'abertura'},
        {label: 'Livro', field: 'a.numero_controle_livro', headerClass: 'column__codigo_doc', name: 'codigo'},
        {label: 'Folha Inicial', field: 'a.numero_controle_folha', headerClass: 'column__codigo_doc', name: 'codigo'},
        {label: 'Folha Final', field: 'a.numero_controle_folha_final', headerClass: 'column__codigo_doc', name: 'codigo'},
        {label: 'Status', field: 'i.status', headerClass: 'column__status', name: 'status'}
      ]
      return columns;
    },
    statusSelecionado() {
      return this.buscar === 'PRE_MATRICULA' ? 'PENDENTE' : 'ABERTA';
    },

    auditor() {
      return this.$root.isAuditorOnly;
    },

    exportar(){
      let forms = {
        direction:"desc",
        sort:"i.codigo",
        preMatricula: this.status == 'PENDENTE',
        filtros:Utils.clone([...this.filtros?.filtros].filter(e => e.id))
      };

      let envolvido_nome = forms.filtros.find(f => f.id == 'envolvido_nome');

      if(envolvido_nome) {
        envolvido_nome.value = {
          envolvido_nome: envolvido_nome.value,
          envolvido_papel: this.filtros.envolvidoPapel === "TODOS" ? null : this.filtros.envolvidoPapel
        }
      }
      return this.mode === 'novo' && !this.auditor ? {id: "EXPORTAR_REGISTRO_NOTAS", forms, extensao: "XLSX"} : null;
    },

    actions() {
      let actions = [];
      if (this.auditor) return actions;
      return  Utils.orderBy(actions, 'ordem');
    }
  },
  mounted() {
    this.filtros.filtros = [{id: "tipo_registro",type: null,value: this.registro || 'ESCRITURA', hiddenActions: true, disabled: false}]
    this.load();
  },
  methods:{
    formatarCodigo : FrontBusiness.formatarCodigo,
    async load() {
      this.opcoesConsulta.push({unificado: true, livro: null, status: ['ABERTA','CANCELADA','ENCERRADA'],id: 'usuario_alteracao_manual', nome: 'Usuário da Alteração Manual', type: 'list', options: await UsuarioBusiness.getAllSimpleList()},)
    },
    close(){
      FrontBusiness.closeModal();
    },
    select(registro) {
      this.seleciona ? FrontBusiness.closeModal(registro) : this.detalhes(registro?.id);
    },
    async process(sort_by, sort_dir, page_length, page_number){
      let filtros = Utils.clone([...this.filtros?.filtros].filter(e => e.id));
      let preMatricula = this.status == 'PENDENTE';
      let envolvido_nome = filtros.find(f => f.id == 'envolvido_nome');

      if(envolvido_nome) {
        envolvido_nome.value = {
          envolvido_nome: envolvido_nome.value,
          envolvido_papel: this.filtros.envolvidoPapel?.filter(c => c !== 'TODOS')
        }
      }
      return RegistroNotasBusiness.paginationV2(sort_by, sort_dir, page_number, page_length, {filtros, preMatricula}).then(result => ({rows: result.pagina, total: result.quantidade}));
    },
    detalhes(id){
      FrontBusiness.openModal(DetalhesRegistroNotas, {id});
    },
    tipoRegistro(valor){
      return FrontBusiness.getLabel(valor, RegistroNotasBusiness.getTipos());
    },
    nomearStatus(valor){
      return RegistroNotasBusiness.formatarNomeStatus(valor);
    },
    selecionar(item, nomeFiltro){
      this.$nextTick(() => {
        this.filtros[nomeFiltro] = item ? item.indicadorPessoalId : null;
      });
    },
    remover(idx, lista) {
      this.$nextTick(() => {
        this.filtros[lista].splice(idx, 1);
      });
    },
    selectRegistro(ficha) {
      let index = this.marcados.findIndex(e => e.id === ficha.id);
      if (index >= 0) {
        this.marcados.splice(index, 1)
      } else {
        this.marcados.push(ficha)
      }
    },
    selecionarTodos(limpar = false) {
      this.marcados = [];
      this.$refs?.modal?.$refs?.paginator?.rows.forEach(r => {
        let input = document.getElementById(`check-${r.id}`)
        input.checked = !limpar;
        if (!limpar) this.marcados.push(r)
      })
    },
    async cadastrarAntiga(){
      const indicador = await FrontBusiness.openModal(ModalFichaAntiga, {livro: 'REGISTRO_NOTAS'});
      if(indicador){
        FrontBusiness.openModal(DetalhesRegistroNotas, {id: indicador});
      }
    },
    consultarPreRegistro() {
      FrontBusiness.closeModal();
      FrontBusiness.openModal(ConsultarRegistroNotas, {status : 'PENDENTE', seleciona: false}, 1300, true);
    },
    selecionarFichas(nomeFiltro, item, add, x){
      this.$nextTick(() => {
        nomeFiltro = nomeFiltro || x;
        this.filtros[nomeFiltro] = item[0] ? item[0].id : null;
        this[nomeFiltro] = item[0] ? String(item[0].codigo) + (item[0]?.livroLetra || '') : null;
        if (add && item[0]) {
          this.executeLoad();
        }
      });
    },
  }
}
</script>
